import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
export const useCookieStore = create()(persist((set) => ({
    posthogId: '',
    setPosthogId: (state) => set({ posthogId: state }),
    isPosthogEnabled: false,
    setPosthogEnabled: (state) => set({ isPosthogEnabled: state }),
}), {
    name: 'cookie-storage',
    storage: createJSONStorage(() => sessionStorage),
}));
